import script from "./AssetRepairedLog.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetRepairedLog.vue?vue&type=script&setup=true&lang=js"

import "./AssetRepairedLog.vue?vue&type=style&index=0&id=5be74ae9&scoped=true&lang=css"

import exportComponent from "D:\\Workspace-idea\\vue-space\\hwoms-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5be74ae9"]])

export default __exports__